import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { FeedItemDto } from '@shared/types';

export function useArchive() {
  return useQuery({
    queryKey: ['feed', 'archive'],
    queryFn: async () => (await api.get<{ data: { items: FeedItemDto[] } }>('/feed/archive')).data.items,
  });
}
